import React, { useEffect } from "react";
import { motion } from "framer-motion";
import logoImg from "../assets/logo.png";

const SplashScreen = () => {

  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Fontdiner+Swanky&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
      }}
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0, y: 10 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ opacity: 0, scale: 1.05 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
          padding: "20px"
        }}
      >
        <img
          src={logoImg}
          alt="Sarvagya Logo"
          style={{
            width: "60vw",
            maxWidth: "220px",
            height: "auto",
            objectFit: "contain",
            filter: "drop-shadow(0px 8px 12px rgba(49, 46, 129, 0.15))"
          }}
        />

        <h2 style={{
            margin: "10px 0 0 0",
            padding: 0,
            fontSize: "22px",
            fontWeight: "400",
            letterSpacing: "3px",
            color: "#b45309",
            fontFamily: "'Fontdiner Swanky', serif",
            textTransform: "uppercase",
            textAlign: "center",
            whiteSpace: "nowrap",
            opacity: 0.15,
        }}>
            SARVAGYA
        </h2>

        <h1 style={{
            margin: "2px 0 0 0",
            padding: 0,
            fontSize: "26px",
            fontWeight: "900",
            letterSpacing: "4px",
            color: "#312e81",
            fontFamily: "'Poppins', 'Montserrat', 'Segoe UI', sans-serif",
            textTransform: "uppercase",
            whiteSpace: "nowrap",
            textShadow: "0 4px 6px rgba(49, 46, 129, 0.1)"
        }}>
            STUDENT SATHI
        </h1>

        <p style={{
            margin: "0",
            padding: 0,
            fontSize: "16px",
            fontWeight: "500",
            color: "#6b7280",
            fontFamily: "Devanagari, sans-serif",
            letterSpacing: "1px",
            textAlign: "center"
        }}>
            ✨"छात्रों का डिजिटल साथी"✨
        </p>

      </motion.div>
    </motion.div>
  );
};

export default SplashScreen;